import React from 'react';

const About = () => {
  return (
    <section className="py-20">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">About Us</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Our Mission</h3>
            <p className="text-gray-600 mb-6">
              We help businesses leverage technology to achieve their goals through
              expert consulting, agile practices, and innovative solutions.
            </p>
            <h3 className="text-xl font-semibold mb-4">Our Expertise</h3>
            <p className="text-gray-600">
              With years of experience in software development and digital transformation,
              we bring cutting-edge solutions to complex business challenges.
            </p>
          </div>
          <div className="bg-gray-100 rounded-lg p-8">
            <h3 className="text-xl font-semibold mb-4">Why Choose Us?</h3>
            <ul className="list-disc list-inside text-gray-600">
              <li>Proven track record of successful projects</li>
              <li>Experienced and certified professionals</li>
              <li>Tailored solutions for your business needs</li>
              <li>Commitment to quality and innovation</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
